<template>
  <div>
    <div class="page">
      <a id="credits"></a>
      <div class="left">
        <div class="logo"></div>
        <div class="blue-box">
          <h1>Impressum</h1>
          <p>
            Musikwissenschaftliches Seminar Detmold/Paderborn<br />Hornsche
            Straße 39<br />32756 Detmold
          </p>
          <p style="font-size: 1.5em; font-weight: bold; margin-top: 0;">
            Credits
          </p>
          <p>
            Im Rahmen des Projektseminars „Mobile App zur Musikgeschichte in
            Detmold“ ist im Sommersemester 2018 und Wintersemester 2018/2019 die
            App Detmold Spaziergang unter Beteiligung folgender Studierender der
            Musikwissenschaft entstanden:
          </p>
          <ul style="list-style: none; padding-left: 2ex;">
            <li>Frances Frei</li>
            <li>Moritz Knurr</li>
            <li>Pascal Phillip Mühlenhoff</li>
            <li>Salome Obert</li>
            <li>Samira Pahlkötter</li>
            <li>Judith Leoni Samuel</li>
            <li>Rebecca Schimmelpfennig</li>
            <li>Qi Shan</li>
            <li>Joel Maxim Vieweger</li>
            <li>Qian Wu</li>
          </ul>
          <p style="font-size: 1.25em; font-weight: bold; margin-top: 0;">
            Dozenten:
          </p>
          <ul style="list-style: none; padding-left: 2ex;">
            <li>Prof. Dr. Andreas Münzmay</li>
            <li>Daniel Röwenstrunk</li>
          </ul>
          <p style="font-size: 1.5em; font-weight: bold; margin-top: 0;">
            Rechte Dritter
          </p>
          <ul style="list-style: none; padding-left: 2ex;">
            <li>Design: Samira Pahlkötter</li>
            <li>Eingangsmusik: Pascal Phillip Mühlenhoff</li>
            <li>Foto: Samira Pahlkötter</li>
            <li>Hörfassung: Judith Leoni Samuel</li>
            <li>Logo: Samira Pahlkötter, Joel Maxim Vieweger</li>
          </ul>
            <p>
            <h4>Bahnhof: Salome Obert</h4>Strohmann, Dirk: <em>Das Empfangsgebäude des Detmolder Bahnhofs und sein Fürstenzimmer.</em> Münster 2009.

                Brahms Statue: Salome ObertIRMLIND CAPELLE, Art. Detmold, III.1., in: MGG Online, hrsg. von Laurenz Lütteken, Kassel, Stuttgart, New York 2016ff., veröffentlicht 2016, https://ez-proxy.hfm-detmold.de:2088/mgg/stable/47817 [Zugriff am 02.12.2018].

                Christuskirche: Pascal Phillip MühlenhoffSünder-Gaß, Dr. Martina: Die Christuskirche in Detmold: Ein Führer durch die evangelisch-reformierte Stadtkirche, Detmold 2005.

                Erlöserkirche: Pascal Phillip MühlenhoffEv.-reformierte Kirchengemeinde Detmold-Ost: Die Erlöserkirche am Markt in Detmold, Flyer, Detmold 2015.

                Haus Münsterberg: Qian WuMarlem Dettmer, Lea Beimdiek, Barbara Klaus, Micheline Prüter-Müller: Haus Münsterberg, Lippische Kulturlandschaften, 2017.

                Kaiserkeller: Qian Wu, Salome Oberthttps://www.lz.de/lippe/kreis_lippe/20312773_Kaiserkeller-Detmold-Heimat-fuer-Rock-Pop-Blues-und-Co..html

                Landestheater: Salome ObertIRMLIND CAPELLE, Art. Detmold, IV., in: MGG Online, hrsg. von Laurenz Lütteken, Kassel, Stuttgart, New York 2016ff., veröffentlicht 2016, https://ez-proxy.hfm-detmold.de:2088/mgg/stable/47816 [Zugriff am 02.12.2018].

                Lortzing Haus: Salome ObertIrmlind Capelle, Art. Lortzing, Albert, Biographie, in: MGG Online, hrsg. von Laurenz Lütteken, Kassel, Stuttgart, New York 2016ff., zuerst veröffentlicht 2004, online veröffentlicht 2016, https://ez-proxy.hfm-detmold.de:2088/mgg/stable/14876 [Zugriff am 18.11.2018].

                Ludwig Altenbernd Haus: Qian Wu, Salome ObertLexikon Westfälischer Autorinnen und Autoren. 1750 bis 1950. Ludwig Altenbernd. https://www.lwl.org/literaturkommission/alex/index.php?id=00000003&letter=A&layout=2&author_id=00000277 Zugriff am 06.02.2019.

                Lippische Landesbibliothek. Autorenlexikon. Altenbernd, Ludwig. http://www2.llb-detmold.de/Autoren/Alte_L.pdf Zugriff am 06.02.2019.

                Lippische Landesbibliothek. Autorennachlässe und Sammlungen. http://www.llb-detmold.de/sammlungen/literaturarchiv/nachlaesse-und-autographen/nachlaesse.html Zugriff am 06.02.2019.

                Marktplatz: Qian WuArnold Ebert: Detmold – eine wunderschöne Stadt, Detmold 1987.

                Martin Luther Kirche: Pascal Phillip MühlenhoffEv.-lutherische Kirchengemeinde Detmold: detmold-lutherisch: Glauben & Geschichte, Flyer, Detmold 2018.
            Ev.-lutherische Kirchengemeinde Detmold: Martin-Luther-Kantorei, Flyer, Detmold 2018https://www.detmold-lutherisch.de/orte/martin-luther-kirche/, 17.01.2019.

                Musikbibliothek: Salome ObertDer Neubau der Musikbibliothek. http://www.hfm-detmold.de/studium/bibliothek/neubau/ [Zugriff am 04.12.2018]

                Palais: Pascal Phillip Mühlenhoff, Salome ObertMüller-Dombois, Richard: Die Gründung der Nordwestdeutschen Musikakademie Detmold, Detmold 1977 (Beiträge zur westfälischen Musikgeschichte, Heft 13).

                Peters, Gerhard: Das Fürstliche Palais in Detmold: Architektur und Geschichte 1700 bis 1950, Blomberg u. Bielefeld 1984 (Sonderveröffentlichungen des Naturwissenschaftlichen und Historischen Vereins für das Land Lippe, Bd. 34).

                Palaisgarten: Pascal Phillip Mühlenhoff, Salome ObertDann, Thomas: Das Neue Palais in Detmold, Detmold 2010 (Lippische Kulturlandschaften, Heft 16, 1. Auflage).

                Schütze, Peter: „Also um eins, auf der langen Straße“: Geschichten und Anekdoten aus dem alten Detmold, Gudensberg-Gleichen 2006.

                Schloss: Pascal Phillip Mühlenhoff, Salome ObertCapelle, Irmlind: Art. Detmold, in: Die Musik in Geschichte und Gegenwart, hrsg. von Ludwig Finscher, Kassel u.a. 1995 (zweite, neubearbeitete Ausgabe), Sp. 1162-1169.

                Wagner Statue: Salome ObertIffland, Joachim. Vorwort. In: Lippes Grüner Hügel. Die Richard-Wagner-Festwochen in Detmold 1935-1944. Projekt Lippes Grüner Hügel (Hrsg.). Detmold 2012. S. 7-9.

                Marcel Oeben. Ein Brunnen für den Führer – das Scheitern eines Erinnerungsprojektes. Lemgo 2017. https://www.stadtarchiv-lemgo.de/fileadmin/image/Digitale_Angebote/20170803094836.pdf [Zugriff am 25.01.2019]

                Wagner in Detmold 1855-1945. Eine Ausstellung im Landestheater anlässlich der Ring-Inszenierung vom 3. Oktober bis 16. Dezember 2009. Lippische Landesbibliothek 2009. http://www.llb-detmold.de/wir-ueber-uns/aus-unserer-arbeit/ausstellungen/ausstellung-2009-5.html [Zugriff am 08.12.2018]


          <p style="font-size: 1.5em; font-weight: bold; margin-top: 0;">
            Danksagung
          </p>
          <p>Ein besonderer Dank für die freundliche Unterstützung gilt:</p>
          <ul style="list-style: none; padding-left: 2ex;">
            <li>Dr. Irmlind Capelle</li>
            <li>Bodo Janßen</li>
            <li>Kristijana Lucic</li>
            <li>Theodora Oancea</li>
            <li>Johannes Pöld</li>
            <li>Hendrick Säck</li>
          </ul>
          <p style="font-size: 1.5em; font-weight: bold; margin-top: 0;">
            Datenschutz
          </p>
          <p>Kontaktdaten</p>
          <p>
            Verantwortlich für die Verarbeitung ist die Universität Paderborn,
            eine vom Land NRW getragene, rechtfähige Körperschaft des
            Öffentlichen Rechts. Sie wird vertreten durch die Präsidentin.
          </p>
          <p>
            Universität Paderborn<br />Warburger Straße 100<br />33098 Paderborn
          </p>
          <p>Tel.: 05251 60-0<br />Web.: http://www.uni-paderborn.de</p>
          <p>Ansprechpartner für technische Fragen</p>
          <p>
            Daniel Röwenstrunk<br />E-Mail: roewenstrunk@upb.de<br />Tel.: 05231
            975662<br />Web.: https://www.uni-paderborn.de/person/439/
          </p>
          <p>Kontaktdaten des Datenschutzbeauftragten</p>
          <p>
            Den Datenschutzbeauftragten erreichen Sie postalisch unter der
            Adresse des Verantwortlichen oder wie folgt:
          </p>
          <p>
            E-Mail: datenschutz@uni-paderborn.de<br />Tel.: 05251 60-2400<br />Web.:
            http://www.uni-paderborn.de/datenschutz
          </p>
          <p>Verarbeitete personenbezogenen Daten und Zwecke</p>
          <p>
            Im Rahmen der App „Detmold Spaziergang“ der Universität Paderborn
            werden keine personenbezogene Daten von Ihnen erhoben oder
            verarbeitet.
          </p>
          <p>Ihre Rechte als betroffene Person</p>
          <p>
            Sie können als betroffene Person jederzeit die Ihnen durch die
            EU-DSGVO gewährten Rechte geltend machen: Das Recht auf Auskunft, ob
            und welche Daten von Ihnen verarbeitet werden (Art. 15 EU-DSGVO),
            das Recht, die Berichtigung oder Vervollständigung der Sie
            betreffenden Daten zu verlangen (Art. 16 EU-DSGVO), das Recht auf
            Löschung der Sie betreffenden Daten nach Maßgabe des Art. 17
            EU-DSGVO, das Recht, nach Maßgabe des Art. 18 EU-DSGVO eine
            Einschränkung der Verarbeitung der Daten zu verlangen, das Recht
            eine erteilte Einwilligung jederzeit zu widerrufen. Die
            Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf
            erfolgten Verarbeitung wird dadurch nicht berührt (Art. 7 Abs. 3
            EU-DSGVO), das Recht auf Widerspruch gegen eine künftige
            Verarbeitung der Sie betreffenden Daten nach Maßgabe des Art. 21
            EU-DSGVO. Sie haben über die genannten Rechte hinaus das Recht, eine
            Beschwerde bei der datenschutzrechtlichen Aufsichtsbehörde
            einzureichen (Art. 77 EU-DSGVO), zum Beispiel bei der für die
            Hochschule zuständigen
          </p>
          <p>
            Landesbeauftragten für Datenschutz und Informationsfreiheit
            Nordrhein-Westfalen
          </p>
          <p>Kavalleriestraße 2-4<br />40213 Düsseldorf</p>
          <p>Tel.: 0211 38424-0<br />E-Mail: poststelle@ldi.nrw.de</p>
          <p>Gültigkeit dieser Datenschutzhinweise</p>
          <p>
            Wir behalten uns das Recht vor, diese Datenschutzhinweise
            abzuändern, um sie gegebenenfalls an Änderungen relevanter Gesetze
            bzw. Vorschriften anzupassen oder Ihren Bedürfnissen besser gerecht
            zu werden. Diese Datenschutzhinweise gelten in der jeweils zuletzt
            durch die Universität veröffentlichten Fassung.
          </p>
        </div>
      </div>
      <div class="right" id="schloss"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "credits"
};
</script>

<style scoped lang="scss">
#schloss {
  background-image: url("../assets/Schloss.jpg");
}

    h4 {
        margin-bottom: 0.5em;
    }
</style>
